import React, { FC, useState } from "react";
import { Launch, applestore, googleplay, phones } from "../../../assets/images";
import { IoClose, IoHourglassOutline } from "react-icons/io5";

const DownloadApp: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClick = () => {
    setIsModalOpen(true);
  };
  return (
    <div className="w-full mx-auto mt-[80px] md:mt-[400px]">
      <div className=" w-full flex flex-col  bg-[rgba(47,247,122,0.13)] ">
        {/* DOWNLOAD */}
        <div
          onClick={() => handleClick()}
          className="w-full md:w-4/5 container flex bg-gradient-to-r from-lightGreen to-[#c5e4d0] mx-auto border rounded-[10px] md:rounded-[30px] -mt-[50px] md:-mt-[200px] justify-between py-2 px-10 md:px-24 "
        >
          <div className="w-1/2 flex flex-col gap-1 lg:gap-10 md:w-1/3 md:justify-center">
            <div className="flex flex-col gap-3">
              <h2 className="text-darkText font-Poppins font-bold text-[13px] md:text-[25px] lg:text-[40px]">
                Coming Soon: Download Ecomoto App for free
              </h2>
              <span className="text-black font-Poppins text-[7px] md:text-[13px] lg:text-[18px] font-normal">
                For faster, easier booking and exclusive deals
              </span>
            </div>
            <div className="flex gap-3">
              <img
                src={applestore}
                alt=""
                className="h-20 w-20 cursor-pointer"
              />
              <img
                src={googleplay}
                alt=""
                className="h-20 w-20 cursor-pointer"
              />
            </div>
          </div>
          {/* PHONE */}
          <div className=" w-1/2 mt-[-50px]  lg:-mt-44 md:mb-10">
            <img src={phones} alt="" />
          </div>
        </div>
        {/* LAUNCH */}
        <div className="w-4/5 container flex mx-auto md:p-14 justify-between">
          <div className="flex flex-col gap-6 pb-4 lg:gap-12 w-1/3">
            <h2 className="text-black font-Inter text-[11px] md:text-[20px] lg:text-[30px] font-medium ">
              Be the first to know when we LAUNCH
            </h2>
            {/* <p className="text-black font-Poppins text-[6px] md:text-[12px] lg:text-[15px] font-medium ">
              Lorem ipsum dolor sit amet consectetur. Sollicitudin vestibulum
              sapien fames sollicitudin velit consequat. Egestas tincidunt non a
              posuere quis.
            </p> */}
            <form action="" className=" flex gap-1 md:gap-5">
              <input
                type="text"
                placeholder="Enter your email address"
                className="border rounded-lg px-[8px] py-[2px] md:px-[20px] lg:px-[40px] md:py-[10px] items-center bg-none text-[#33363F] font-Poppins text-[12px]  md:text-[16px]"
              />
              <button
                type="submit"
                className="px-[12px] py-[4px] md:px-[20px] lg:px-[40px] md:py-[10px] text-white bg-darkGreen rounded-lg font-Poppins  text-[16px]"
              >
                Subscribe
              </button>
            </form>
          </div>
          <div className="w-1/3">
            <img src={Launch} alt="" />
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 py-5 sm:p-6 w-full">
                <div className="sm:flex flex-col gap-10 sm:items-start w-full mx-auto">
                  <div className="w-full ml-auto">
                    <button
                      aria-label="exit"
                      type="button"
                      className=" text-white rounded-full px-4 py-2 m-2"
                      onClick={() => setIsModalOpen(false)}
                    >
                      <IoClose className="h-6 w-6 text-black" />
                    </button>
                  </div>
                  <div className=" flex w-full flex-col justify-center gap-3 items-center">
                    <IoHourglassOutline
                      id="hourglass"
                      size={80}
                      className=" text-midGreen"
                    />
                    <h3
                      className="text-xl leading-6 font-medium font-Poppins text-darkGreen uppercase"
                      id="modal-title"
                    >
                      Coming Soon
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadApp;
